'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);









function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRight = function ArrowRight(props) {
  return _react2.default.createElement(
    'svg',
    { style: {width: (props.size || '24px'), height: (props.size || '24px')}, viewBox: (props.viewBox || '0 0 24 24'), className: props.className },
    _react2.default.createElement('path', { d: 'M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z' })
  );
};

ArrowRight.displayName = 'ArrowRight';


exports.default = ArrowRight;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-mdi/icons/arrow-right.js
 ** module id = 214
 ** module chunks = 0
 **/